import React from "react";

function BuyMeACoffee(props) {
  return (
    <a href="https://www.buymeacoffee.com/calebschoepp" className="m-4">
      <img
        src="/BuyMeACoffee.png"
        width="50"
        height="50"
        alt="Buy Me A Coffee"
      />
    </a>
  );
}

export default BuyMeACoffee;
